import React from "react";
import RisksClassification from "src/pages/Risks/Classification";
import RisksMatrix from "src/pages/Risks/Matrix";
import RisksPanel from "src/pages/Risks/Panel";
import RoutePrivate from "./private";

export default [
	<RoutePrivate path="/risks/matrix" key="risksMatrix" exact component={RisksMatrix} isPrivate/>,
	<RoutePrivate path="/risks/classification" key="risksClassification" exact component={RisksClassification} isPrivate/>,
	<RoutePrivate path="/risks/panel" key="risksPanel" exact component={RisksPanel} isPrivate/>,
	<RoutePrivate path="/risks/panel/:riskId" permissionPath="/risks/panel" key="risksPanelId" exact component={RisksPanel} isPrivate/>
];
